export enum HttpStatus {
   '401' = { code: 401, name: 'unauthorized', actions: 'sign_out' },
   '403' = { code: 403, name: 'forbidden', actions: 'both' },
   '404' = { code: 404, name: 'not_found', actions: 'return' },
}
